import { stringToDate } from 'modules/core/lib/dates'
import type Company from 'modules/core/store/models/Company'

import { supplementTaxonomyName } from 'modules/contracts/store/collections/taxonomies'
import type { IncidenceChangeItem } from 'modules/payroll_bundle/lib/types'
import { centsToString } from 'modules/payroll_bundle/lib/utils'
import supplementObservations from 'modules/payroll_bundle/store/collections/supplementObservations'
import type { Supplements } from 'modules/payroll_bundle/store/collections/supplements'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

const supplementsAmount = (supplement: Supplement, company: Company): string | null => {
  return centsToString(supplement.attributes.amount_in_cents, supplement.attributes.unit, company)
}

const supplementObservation = (supplement: Supplement) => {
  return (
    supplementObservations.find((so) => so.get('supplement_id') === supplement.id)?.get('text') ??
    ''
  )
}

const buildSupplementChanges = (
  supplementCollection: Supplements,
  company: Company
): IncidenceChangeItem[] => {
  return supplementCollection.map((supplementChange: Supplement) => {
    return {
      id: 'supplements',
      effectiveAt: stringToDate(supplementChange.attributes.created_at, 'backend_datetime'),
      currentValue: {
        ...supplementChange.toJS(),
        taxonomyName: supplementTaxonomyName(supplementChange),
        observation: supplementObservation(supplementChange),
        amount: supplementsAmount(supplementChange, company),
      },
      previousValue: {},
    }
  })
}

export default buildSupplementChanges
